import { NgClass, NgIf } from "@angular/common";
import { Component } from "@angular/core";
import { environment } from "@env/environment";

@Component({
    selector: 'lpcr-environment-badge',
    templateUrl: './environment-badge.component.html',
    imports: [NgClass, NgIf]
})
export class EnvironmentBadgeComponent {
  public readonly environmentType = environment.type;
}
